
import React from 'react'
import '../Styles/signUp.css'
import '../BackGround.css'
import { Container } from 'react-bootstrap'
import src from '../Styles/ECLOGOSVG.svg'
import RedditTextField from '../components/reddit-textfield'
import { IMaskInput } from 'react-imask'
import PropTypes from 'prop-types';
import { IconButton, InputAdornment } from '@mui/material'
import { MdVisibility, MdVisibilityOff } from 'react-icons/md'

const TextMaskCustom1 = React.forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="+7 (#00) 000-0000"
      definitions={{
        '#': /[1-9]/,
      }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});
TextMaskCustom1.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

function Maintanance() {

  const [userdata, setUserdata] = React.useState({
    username:  '',
    surname:  '',
    patronymic:  '',
    birthdate: '',
    phone:  '',
    email:  '',
    password:  '',
  });

  const handleChange = (e) => {
    e.preventDefault()
    const value = e.target.value
    setUserdata({
      ...userdata,
      [e.target.name]: value
    })
  };

  const handleChange1 = (e) => {
    // e.preventDefault()
    const value = e.target.value
    setUserdata({
      ...userdata,
      [e.target.name]: value
    })
  };

  

  const [showPassword, setShowPassword] = React.useState(false)
  const handleClickShowPassword = () => setShowPassword(!showPassword)
  const handleMouseDownPassword = () => setShowPassword(!showPassword)
  
  return (
    <>
      <a href='/'><img src={src} className='imgLogo' alt='imglogo'/></a>
      <Container className='FormGroupR' style={{width:'580px'}}>
        <h1>В данный момент личный кабинет находится в разработке</h1>
        <form className='ECformR'>
          <div >
            <RedditTextField disabled id='surname' type='text' label='Фамилия' variant='filled' name='surname' value={userdata.surname} onChange={handleChange} />
          </div>
          <Container className='InputRow'>
            <div >
                <RedditTextField disabled id='username' type='text' label='Имя' variant='filled' name='username' value={userdata.username} onChange={handleChange} />
              </div>
              <div >
                <RedditTextField disabled id='patronymic' type='text' label='Отчество (при наличии)' variant='filled' name='patronymic' value={userdata.patronymic} onChange={handleChange}/>
              </div>
          </Container>
          <div>
            <RedditTextField disabled id='birthdate' name='birthdate' type='date' label='Дата рождения' variant='filled' value={userdata.birthdate} onChange={handleChange} InputProps={{ disableUnderline:true }} inputProps={{ min: "1922-01-01", max: "2023-01-01"}} InputLabelProps={{shrink:true}}/>
          </div>
          <Container className='InputRow'>
            <div>
              <RedditTextField disabled id='phone' label='Контактный номер' variant='filled' name='phone' value={userdata.phone} onChange={handleChange1} InputProps={{inputComponent: TextMaskCustom1, disableUnderline: true, }} />
            </div>
            <div >
              <RedditTextField disabled id='email' type='email' label='Ваш email' variant='filled' name='email' value={userdata.email} onChange={handleChange} />
            </div>
          </Container>
          <div>
            <RedditTextField disabled id='password' type={showPassword ? "text" : "password"} label='Придумайте пароль' variant='filled' name='password'  value={userdata.password} onChange={handleChange} InputProps={{
              disableUnderline: true,
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="password-visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                  >
                    {showPassword ? <MdVisibility /> : <MdVisibilityOff />}
                  </IconButton>
                </InputAdornment>
              )
            }}/> 
          </div >
          {/* <ButnotP type='submit' id='ButnotP1' name={loginLoading === true ? (<Spinner animation="border" style={{marginTop:'6px', scale:'80%'}}/>) : (<span>Продолжить</span>)} loading={loginLoading} /> */}
          
        </form>
        <p id='NoAccountR'>Есть аккаунт? <a href='/login' style={{margin:'10px'}}>Войти</a></p>
      </Container>
    </>
  )
}

export default Maintanance